import { post } from './api';

export function fileWitnessReport(
  code: string,
  token: string,
  killerName: string,
  victimName: string,
): Promise<{ report_id: number }> {
  return post(`/games/${code}/witness/report/`, { token, killer_name: killerName, victim_name: victimName });
}

export function respondToReport(
  code: string,
  token: string,
  reportId: number,
  accept: boolean,
  reason: string = '',
): Promise<void> {
  return post(`/games/${code}/witness/respond/`, { token, report_id: reportId, accept, reason });
}

export function moderatorRuling(
  code: string,
  moderatorName: string,
  reportId: number,
  ruling: 'arrest' | 'confirm_kill' | 'dismiss',
): Promise<void> {
  return post(`/games/${code}/witness/ruling/`, { moderator_name: moderatorName, report_id: reportId, ruling });
}
